<template>
  <div>
    <v-dialog v-model="visible" max-width="800px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>公司授权个人付费说明</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <ul class="health-list">
            <li>投保单位因业务需要委托付款人为投保单位合法直付保险保费，</li>
            <li>付款人的付款行为，均代表投保单位，与投保单位的付款行为具有同等法律效力。</li>
            <li>特此说明。</li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>